export default class AgeGate {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.initAgeGate();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Shows or hides the age gate on page load
  //===========================================================================

  initAgeGate() {
    const $ageGate = $('.js-age-gate');
    const $buttons = $ageGate.find('.js-age-gate-btns');
    const $message = $ageGate.find('.js-age-gate-message');
    const $content = $ageGate.find('.js-age-gate-content');

    if (document.cookie.includes('ageGate=1')) {
      $ageGate.hide();
    } else if (document.cookie.includes('ageGate=2')) {
      $buttons.hide();
      $message.show();
      $content.removeClass('invisible');
    } else {
      $content.removeClass('invisible');
    }
  }

  //===========================================================================
  // After the user interacts with the age gate form
  //===========================================================================

  onButtonClick(e) {
    const $target = $(e.currentTarget);
    const value = $target.data('type');
    const date = new Date();

    date.setDate(date.getDate() + 30);
    $('html')[0].scrollTop = 0;

    if (value === 'yes') {
      document.cookie = `ageGate=1; expires=${ date }; path=/`;
      $('.js-age-gate').fadeOut(600);
    } else {
      document.cookie = `ageGate=2; expires=${ date }; path=/`;
      $('.js-age-gate-btns').hide();
      $('.js-age-gate-message').show();
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-age-gate-btn', this.onButtonClick.bind(this));
  }
}
